export const STEPS_TARGET = 'steps';

export const OFFER_TARGET = 'offer';

export const CHECK_OFFER_ID_TARGET = 'checkOfferId';

export const PROMO_BUILDER_OFFER_TARGET = 'promoBuilderOffer';

export const BYOP_GROUPABLE_ID = 'byopGroupableId';
